<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="vertical">
          <a-row :gutter="48">
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="阴保类型"
                prop="deviceTypeId"
              >
                <a-select
                  v-model="queryParam.deviceTypeId"
                  placeholder="请选择阴保类型"
                  allow-clear
                >
                  <a-select-option
                    v-for="item in deviceTypeList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="风险等级"
                prop="riskLevel"
              >
                <a-select
                  v-model="queryParam.riskLevel"
                  placeholder="请选择风险等级"
                  allow-clear
                >
                  <a-select-option
                    :key="1"
                    :value="1"
                  >高</a-select-option>
                  <a-select-option
                    :key="2"
                    :value="2"
                  >中</a-select-option>
                  <a-select-option
                    :key="3"
                    :value="3"
                  >低</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="故障或风险描述"
                prop="faultOrRiskDescription"
              >
                <a-input
                  v-model="queryParam.faultOrRiskDescription"
                  placeholder="请输入故障或风险描述"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced"
            >
              <a-form-item
                label="诊断标准"
                prop="diagnosticCriteria"
              >
                <a-input
                  v-model="queryParam.diagnosticCriteria"
                  placeholder="请输入诊断标准"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced"
            >
              <a-form-item
                label="建议措施"
                prop="recommendedMeasure"
              >
                <a-input
                  v-model="queryParam.recommendedMeasure"
                  placeholder="请输入建议措施"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced"
            >
              <a-form-item
                label="评价指标"
                prop="evaluatingIndicator"
              >
                <a-input
                  v-model="queryParam.evaluatingIndicator"
                  placeholder="请输入评价指标"
                  allow-clear
                />
              </a-form-item>
            </a-col>

            <a-col
              :md="!advanced && 6 || 24"
              :sm="24"
            >
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}"
              >
                <a-button
                  type="primary"
                  @click="handleQuery"
                ><a-icon type="search" />查询</a-button>
                <a-button
                  style="margin-left: 8px"
                  @click="resetQuery"
                ><a-icon type="redo" />重置</a-button>
                <a
                  @click="toggleAdvanced"
                  style="margin-left: 8px"
                >
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button
          type="primary"
          @click="$refs.createForm.handleAdd()"
          v-hasPermi="['saifuneng:knowledge:add']"
        >
          <a-icon type="plus" />新增
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span
          slot="riskLevel"
          slot-scope="text, record"
        >
          <a-tag
            v-if="record.riskLevel == 1"
            color="#f50"
          >高</a-tag>
          <a-tag
            v-if="record.riskLevel == 2"
            color="#2db7f5"
          >中</a-tag>
          <a-tag
            v-if="record.riskLevel == 3"
            color="#87d068"
          >低</a-tag>
        </span>
        <span
          slot="createTime"
          slot-scope="text, record"
        >
          {{ parseTime(record.createTime) }}
        </span>
        <span
          slot="operation"
          slot-scope="text, record"
        >
          <a
            @click="$refs.createForm.handleUpdate(record, undefined)"
            v-hasPermi="['saifuneng:knowledge:edit']"
          >
            <a-icon type="edit" />修改
          </a>
          <a-divider
            type="vertical"
            v-hasPermi="['saifuneng:knowledge:remove']"
          />
          <a
            @click="handleDelete(record)"
            v-hasPermi="['saifuneng:knowledge:remove']"
          >
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageKnowledge, delKnowledge, listDeviceType } from '@/api/saifuneng/knowledge'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'User',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      deviceTypeList: [],
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        deviceTypeId: undefined,
        riskLevel: undefined,
        faultOrRiskDescription: undefined,
        diagnosticCriteria: undefined,
        recommendedMeasure: undefined,
        evaluatingIndicator: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '阴保类型',
          dataIndex: 'deviceTypeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '风险等级',
          dataIndex: 'riskLevel',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'riskLevel' }
        },
        {
          title: '故障或风险描述',
          dataIndex: 'faultOrRiskDescription',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '诊断标准',
          dataIndex: 'diagnosticCriteria',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '建议措施',
          dataIndex: 'recommendedMeasure',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '评价指标',
          dataIndex: 'evaluatingIndicator',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getDeviceTypeList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询用户信息列表 */
    getList () {
      this.loading = true
      pageKnowledge(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userName: undefined,
        companyName: undefined,
        companyAddress: undefined,
        mobile: undefined,
        email: undefined,
        nickname: undefined,
        sex: undefined,
        invitationCode: undefined,
        isNotice: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中阴保类型为【' + row.deviceTypeName + '】的数据',
        onOk () {
          return delKnowledge({ "ids": [row.id] })
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.id = {}
        }
      })
    },
    // 查询设备类型
    getDeviceTypeList () {
      listDeviceType().then(response => {
        this.deviceTypeList = response.data
      })
    }

  }
}
</script>
